export enum IndexEnum {
  WITHOUT_INDEX = 0,
  CDI_INDEX = 66,
}
